/* eslint-disable max-len */
import React from 'react';

const ConfirmEmail: React.FC<object> = () => {

    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 12C7.59128 12 9.11745 11.3678 10.2427 10.2427C11.3678 9.11745 12 7.59128 12 6C12 4.4087 11.3678 2.88258 10.2427 1.75736C9.11745 0.632138 7.59128 0 6 0C4.4087 0 2.88258 0.632138 1.75736 1.75736C0.632138 2.88258 0 4.4087 0 6C0 7.59128 0.632138 9.11745 1.75736 10.2427C2.88258 11.3678 4.4087 12 6 12ZM8.78025 5.03025C8.9169 4.8888 8.9925 4.69935 8.99078 4.5027C8.98905 4.30605 8.91015 4.11794 8.7711 3.97889C8.63205 3.83983 8.44395 3.76095 8.2473 3.75925C8.05065 3.75754 7.8612 3.83313 7.71975 3.96975L5.25 6.4395L4.28025 5.46975C4.1388 5.33313 3.94935 5.25754 3.7527 5.25925C3.55605 5.26095 3.36794 5.33983 3.22889 5.47888C3.08983 5.61794 3.01095 5.80605 3.00925 6.0027C3.00754 6.19935 3.08313 6.3888 3.21975 6.53025L4.71975 8.03025C4.8604 8.17087 5.05113 8.24985 5.25 8.24985C5.44887 8.24985 5.6396 8.17087 5.78025 8.03025L8.78025 5.03025Z"
                fill="#616E6E"
            />
        </svg>
    );
};

export default ConfirmEmail;